<template>
  <div>
    <a-spin :spinning="loading">
      <a-skeleton v-show="loading" :paragraph="{rows: 3}" />
    </a-spin>
    <!-- 表单 -->
    <div v-if="!loading">
      <s-table
        style="display: table;"
        ref="table"
        size="small"
        rowKey="id"
        showQuickJumper
        :columns="columns"
        :data="loadData"
      >
        <template slot="operationType" slot-scope="text,record">
          <span v-if="record.operationType ==='A'">Add</span>
          <span v-else-if="record.operationType ==='B'">Modify</span>
          <span v-else-if="record.operationType ==='C'">Delete</span>
          <span v-else>Recovery</span>
        </template>
        <template slot="changeFrom" slot-scope="text,record">
          <span v-if="record.changeFrom ==='A'">CDB</span>
          <span v-else>OBS</span>
        </template>
        <template slot="updateInfo" slot-scope="updateInfo, row">
          <div v-if="updateInfo">
            <div v-for="(group, groupIndex) in row.updateGroupList" :key="row.id + '-' + groupIndex">
              <div style="font-weight: 500;">{{ group.name }}</div>
              <div v-for="(item, itemIndex) in group.itemList" :key="row.id + '-' + groupIndex + '-' + itemIndex">
                <span style="color: #000000D9;">{{ item.name }}: </span><span>{{ item.before }}</span> <a-icon type="arrow-right" style="margin: 0 10px;" /><span>{{ item.after }}</span>
              </div>
            </div>
          </div>
        </template>
        <!-- <template slot="beforeChangeData" slot-scope="data, row">
          <div v-if="data">
            <span class="dataText">
              <span>Last:</span>
              <span>{{ data.lastName }}</span>
            </span>
            <span class="dataText">
              <span>First:</span>
              <span>{{ data.firstName }}</span>
            </span>
            <span class="dataText">
              <span>Middle:</span>
              <span>{{ data.middleName}}</span>
            </span>
            <span class="dataText">
              <span>Gender:</span>
              <span>{{ data.gender }}</span>
              </span>
            <span class="dataText">
              <span>DOB:</span>
              <span v-if="data.birthday">{{ data.birthday[1] + '/' + data.birthday[2] + '/' + data.birthday[0] }}</span>
            </span>
            <div v-if="data.contactList && data.contactList.length > 0">
              <span v-for="(contact, contactIndex) in data.contactList" :key="row + '-' + contactIndex">
                <span v-if="contact.contactType === '1'" class="dataText">
                  <span>Email:</span>
                  <span> {{ contact.email }}</span>
                </span>
                <span v-else class="dataText">
                  <span>Phone:</span>
                  <span v-if="contact.phoneCountryCode && contact.phoneCountryCode.length > 0">{{ contact.phoneCountryCode }}</span>
                  <span>{{ contact.phoneNumber }}</span>
                  <span v-if="contact.phoneExt && contact.phoneExt.length > 0">{{ contact.phoneExt }}</span>
                </span>
              </span>
            </div>
          </div>
        </template> -->
      </s-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import STable from '@/components/table/'
import { toSTablePage } from '@/utils/util'
import OperationlogApi from '@/api/api-cdb-customer-operationlog'
import { Title, RealationShip } from '@/utils/helper/standard-code-utils'
import { Language, Background, Ethnicities, Meals, Special } from '@/utils/helper/dict-cdb-utils'
import CountryApi from '@/api/basicdata/api-country'
import StateApi from '@/api/basicdata/api-state'

export default {
  name: 'CdbCustomerLogs',
  components: {
    STable
  },
   props: {
    customerId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: { customerId: this.customerId },
      titleList: Title.dict,
      backgroundList: [],
      ethnicitiesList: [],
      languageList: [],
      mealsList: null,
      specialList: null,
      // 表头
      columns: [
        {
          title: 'Date/Time',
          dataIndex: 'changeTime',
          align:'center',
          customRender: (value, record) => this.DateTimeUtil().localString(value !== null ? value : record.changeTime, 'MM/DD/YYYY hh:mm:ss')
        },
        {
          title: 'Type',
          dataIndex: 'operationType',
          align:'center',
          scopedSlots: { customRender: 'operationType' }
        },
        {
          title: 'From',
          dataIndex: 'changeFrom',
          align:'center',
          scopedSlots: { customRender: 'changeFrom' }
        },
        {
          title: 'CDB By',
          dataIndex: 'changeBy',
          align:'center',
          customRender: (value) => value ? value.userName : ''
        },{
          title: 'Modified Info',
          dataIndex: 'updateInfo',
          width: '360px',
          scopedSlots: { customRender: 'updateInfo' }
        },
        {
          title: 'OBS By',
          align:'center',
          dataIndex: 'obsOperatorName',
          customRender: (value) => value ? value : ''
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        parameter.curPage = parameter.pageNo
        return OperationlogApi.queryNew(Object.assign(parameter, this.queryParam))
          .then(res => {
            const list = res.data.datas
            if (list && list.length > 0) {
              list.forEach(it => {
                // it.beforeChangeData = (it.beforeChangeData && it.beforeChangeData.length > 0) ? JSON.parse(it.beforeChangeData) : null
                it.updateInfo = (it.updateInfo && it.updateInfo.length > 0) ? JSON.parse(it.updateInfo) : null
                if (it.updateInfo) {
                  it.updateGroupList = it.updateInfo.groupList
                  if (it.updateGroupList && it.updateGroupList.length > 0) {
                    for (let i=0; i<it.updateGroupList.length; i++) {
                      const itemList = it.updateGroupList[i].itemList
                      if (itemList && itemList.length > 0) {
                        for (let j=0; j<itemList.length; j++) {
                          const item = itemList[j]
                          // 处理title
                          if (item.name === 'Title') {
                            item.before = (item.before && item.before !== '') ? (
                              this.titleList.filter(tmp => tmp.code == item.before)[0].enName
                            ) : 'N/A'
                            item.after = (item.after && item.after !== '') ? (
                              this.titleList.filter(tmp =>tmp.code == item.after)[0].enName
                            ) : 'N/A'
                          }
                          // Primary Language
                          if (item.name === 'Primary Language') {
                            item.before = (item.before && item.before !== '') ? (
                              this.languageList.filter(tmp => tmp.code == item.before)[0].enName + ' (' + this.languageList.filter(tmp => tmp.code == item.before)[0].lgCode + ')'
                            ) : 'N/A'
                            item.after = (item.after && item.after !== '') ? (
                              this.languageList.filter(tmp =>tmp.code == item.after)[0].enName + ' (' + this.languageList.filter(tmp => tmp.code == item.after)[0].lgCode + ')'
                            ) : 'N/A'
                          }

                          // Origin
                          if (item.name === 'Origin') {
                            item.before = (item.before && item.before !== '') ? (
                              this.backgroundList.filter(tmp => tmp.code == item.before)[0].enName
                            ) : 'N/A'
                            item.after = (item.after && item.after !== '') ? (
                              this.backgroundList.filter(tmp =>tmp.code == item.after)[0].enName
                            ) : 'N/A'
                          }
                          // Ethnicities
                          if (item.name === 'Ethnicities') {
                            item.before = (item.before && item.before !== '') ? (
                              this.ethnicitiesList.filter(tmp => tmp.code == item.before)[0].enName
                            ) : 'N/A'
                            item.after = (item.after && item.after !== '') ? (
                              this.ethnicitiesList.filter(tmp =>tmp.code == item.after)[0].enName
                            ) : 'N/A'
                          }
                          // Relationship
                          if (item.name === 'Realation Ship') {
                            item.before = (item.before && item.before !== '') ? (
                              this.contactList.filter(tmp => tmp.code == item.before)[0].enName
                            ) : 'N/A'
                            item.after = (item.after && item.after !== '') ? (
                              this.contactList.filter(tmp =>tmp.code == item.after)[0].enName
                            ) : 'N/A'
                          }
                          // Country
                          if (item.name === 'Country') {
                            item.before = (item.before && item.before !== '') ? (
                              this.countryList.filter(tmp => tmp.id == item.before)[0].nameEnUs
                            ) : 'N/A'
                            item.after = (item.after && item.after !== '') ? (
                              this.countryList.filter(tmp =>tmp.id == item.after)[0].nameEnUs
                            ) : 'N/A'
                          }
                          // State/Province
                          if (item.name === 'State/Province') {
                            item.before = (item.before && item.before !== '') ? (
                              this.stateList.filter(tmp => tmp.id == item.before)[0].nameEnUs
                            ) : 'N/A'
                            item.after = (item.after && item.after !== '') ? (
                              this.stateList.filter(tmp =>tmp.id == item.after)[0].nameEnUs
                            ) : 'N/A'
                          }
                          // Meals Restrictions
                          if (item.name === 'Meals Restrictions') {
                            item.before = this.getMealsRestrictionByValue(item.before)
                            item.after = this.getMealsRestrictionByValue(item.after)
                          }
                          // Special Requests
                          if (item.name === 'Special Requests') {
                            item.before = this.getSpecialRequestByValue(item.before)
                            item.after = this.getSpecialRequestByValue(item.after)
                          }

                          // 空显示成N/A
                          item.before = item.before === '' ? 'N/A' : item.before
                          item.after = item.after === '' ? 'N/A' : item.after
                        }
                      }
                    }
                  }
                }
              })
            }
            console.log('res.data', res.data)
            return toSTablePage(res.data)
          })
      },
      selectedRowKeys: [],
      selectedRows: [],
      contactList: RealationShip.dict,
      countryList: [],
      stateList: []
    }
  },
  mounted () {
    this.loadInitData()
  },
  methods: {
    async loadInitData () {
      this.loading = true
      this.languageList = await Language.getDict()
      this.backgroundList = await Background.getDict()
      this.ethnicitiesList = await Ethnicities.getDict()
      this.mealsList = await Meals.getDict()
      this.specialList = await Special.getDict()
      const countryListRes = await CountryApi.list()
      this.countryList = countryListRes.data
      const stateListRes = await StateApi.list()
      this.stateList = stateListRes.data
      this.loading = false
    },
    handleSubmit (e) {
      e.preventDefault()
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    refreshCurrentPage () {
      this.$refs.table.refresh(false)
    },
    resetSearchForm () {
      this.queryParam = {
        date: moment(new Date())
      }
    },
    // 获取Meals restriction字符串
    getMealsRestrictionByValue (dataStr) {
      if (!dataStr || dataStr === '') {
        return ''
      }
      let result = ''
      const datas = dataStr.split(',')
      for (let i=0; i<datas.length; i++) {
        const v = datas[i]
        if (v && v.length > 0) {
          result = result + (this.mealsList.filter(tmp => tmp.code == v)[0].enName) + ','
        }
      }
      if (result.length > 0) {
        result = result.substring(0, result.lastIndexOf(','))
      }
      return result
    },
    // 获取Special Request字符串
    getSpecialRequestByValue (dataStr) {
      if (!dataStr || dataStr === '') {
        return ''
      }
      let result = ''
      const datas = dataStr.split(',')
      for (let i=0; i<datas.length; i++) {
        const v = datas[i]
        if (v && v.length > 0) {
          result = result + (this.specialList.filter(tmp => tmp.code == v)[0].enName) + ','
        }
      }
      if (result.length > 0) {
        result = result.substring(0, result.lastIndexOf(','))
      }
      return result
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponet = 'List'
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .ant-advanced-search-form {
  padding-top: 0;
}
.plate-title:before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 15px;
  margin-right: 6px;
  background: #1890ff;
  position: relative;
  top: 3px;
}
.dataText {
  margin-right:12px;
}
.dataText :first-child {
  margin-right:5px;
  font-weight:600;
}
</style>
